import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { wenji } from "libraries/interfaces/IWenji";

@Pipe({
    name: 'airLogo'
})

export class AirLogoPipe implements PipeTransform {

    constructor(
        private readonly httpClient: HttpClient
    ) {
    }

    public transform(carrierCode: string, showLogo: boolean): any {
        const url: string = wenji.locobook.carrierLogos;

        if(!showLogo || !url){
            return carrierCode;
        }

        const completePath: string = `${url}${carrierCode}.png`;

    }
}
